import { ErrorMessage } from './error-message';

export class HttpResponse<TResponse> {
    public status: boolean;
    public message: string;
    public termsaccepted: boolean; // very ugly current api have this field in every response and we needed this is login !! find a solution * can be passed in return data object need to modify login endpoint for the same*
    public errorMessages?: ErrorMessage[];
    public errorStatus?: number;

    constructor(public data?: TResponse) {}

    public hasErrors(): boolean {
        return this.status === false;
    }

    public toErrorString(): string {
      if (!this.hasErrors()) {
          return '';
      }

      let m = '';
      // tslint:disable-next-line:no-non-null-assertion
      this.errorMessages!.forEach(
        e => {
          m += e.message + '\r\n';
      });
      return m;
    }
}
